import * as Yup from 'yup';
import { DictionaryWaterTreatmentMethod } from '../../models';

export function useValidationSchema() {
  return Yup.object<DictionaryWaterTreatmentMethod>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    code: Yup.string().nullable().required('Povinné pole'),
  });
}
